var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.52917 31.2646L24.9292 31.2647",
    stroke: "#00E2BC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.39587 35.9316L23.0625 35.9316",
    stroke: "#00E2BC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.6376 14.1814C26.6376 21.154 20.9801 26.8074 14 26.8074C7.01993 26.8074 1.36248 21.154 1.36248 14.1814C1.36248 7.20888 7.01993 1.55547 14 1.55547C20.9801 1.55547 26.6376 7.20888 26.6376 14.1814Z",
    fill: "#00E2BC",
    stroke: "#0A78CD",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.6232 20.5002V19.0975C19.6232 17.5449 18.3633 16.292 16.8153 16.292H11.1935C9.63957 16.292 8.38562 17.5509 8.38562 19.0975V20.5002",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0018 13.4801C15.5525 13.4801 16.8097 12.224 16.8097 10.6746C16.8097 9.12519 15.5525 7.86914 14.0018 7.86914C12.451 7.86914 11.1938 9.12519 11.1938 10.6746C11.1938 12.224 12.451 13.4801 14.0018 13.4801Z",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.6933 20.6904C35.0896 20.6904 36.2214 19.5596 36.2214 18.1646C36.2214 16.7695 35.0896 15.6387 33.6933 15.6387C32.2971 15.6387 31.1653 16.7695 31.1653 18.1646C31.1653 19.5596 32.2971 20.6904 33.6933 20.6904Z",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.5381 20.3145L23.9308 27.9151",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M30.132 26.756L27.75 24.376L25.3372 26.7867L27.7192 29.1667",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSecurityIcon);
export default __webpack_public_path__ + "static/media/UserSecurityIcon.a098a76565a4ce040f448345e31e894c.svg";
export { ForwardRef as ReactComponent };